
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"red","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","stroke":"none"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11"}})]),_c('path',{attrs:{"data-name":"선 721","fill":"none","stroke":"red","stroke-width":"2","d":"M12 0v24"}}),_c('path',{attrs:{"data-name":"선 722","fill":"none","stroke":"red","stroke-width":"2","d":"M20.485 20.485L12 12"}})])
          )
        }
      }
    